import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { GraphQLQuery } from '../utils/methods/graphql.query';

@Injectable()
export class GetItemOperationsByTerminalAndBatchQuery extends GraphQLQuery {
	override command: DocumentNode = gql`
		query ItemOperations($input: GetItemOperationsByTerminalAndBatchInput!) {
			itemOperations(input: $input) {
				items {
					id
					sourceId
					nextId
					alias
					terminalId
					batchId
					calculatedMillisecondsPerItem
					detailAlias
					group
					itemData
					stockItems {
						amount
						description
						stockItemKey
						unit
					}
					items {
						sequenceNumber
						reordered
						completed
						ready
						location {
							name
							placement
						}
					}
				}
				nextToken
			}
		}
	`;
}
